import React, { useRef, useState } from 'react';

import ArrowBack from '@mui/icons-material/ArrowBackRounded';
import MoreVert from '@mui/icons-material/MoreVertRounded';
import {
  CircularProgress, IconButton, Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';

import { Staff } from '../../../../services/staff/types';
import { useDisableUserMutation, useEnableUserMutation } from '../../../../services/users';
import useSuccess from '../../../../utils/react/hooks/useSuccess';
import { StyledBackdrop, TopButtonsContainer } from '../../index.styles';

import MoreMenu from './MoreMenu';

interface TopBarProps {
  staff?: Staff,
}

const TopBar = ({ staff } : TopBarProps) => {
  const navigate = useNavigate();

  const moreMenuRef = useRef<HTMLButtonElement>(null);
  const [moreMenuOpen, setMoreMenuOpen] = useState(false);

  const [disableUser, {
    isSuccess: isDisableUserSuccess,
    isLoading: isDisableUserLoading,
  }] = useDisableUserMutation();
  const [enableUser, {
    isSuccess: isEnableUserSuccess,
    isLoading: isEnableUserLoading,
  }] = useEnableUserMutation();

  if (!staff) {
    return null;
  }

  const onUserStateToggleClick = () => {
    if (staff?.disabled) enableUser({ userId: staff.id });
    else disableUser({ userId: staff.id });
  };

  const isUserStateToggleLoading = isDisableUserLoading || isEnableUserLoading;

  useSuccess(isDisableUserSuccess, 'User disabled');
  useSuccess(isEnableUserSuccess, 'User enabled');

  return (
    <>
      <StyledBackdrop open={isUserStateToggleLoading}>
        <CircularProgress />
      </StyledBackdrop>
      <TopButtonsContainer>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h5">
          {staff?.name}
        </Typography>
        <IconButton ref={moreMenuRef} onClick={() => setMoreMenuOpen(true)}>
          <MoreVert />
        </IconButton>
      </TopButtonsContainer>
      <MoreMenu
        anchor={moreMenuRef.current}
        open={moreMenuOpen}
        onClose={() => setMoreMenuOpen(false)}
        userEnabled={!staff?.disabled}
        onUserStateToggleClick={onUserStateToggleClick}
      />
    </>
  );
};

export default TopBar;
